import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileCompletionGuard } from './core/guards/profile-completion.guard';
import { EnhancedAuthGuard } from './core/guards/enhanced-auth.guard';
import { LegacyOrganigramGuard } from './core/guards/legacy-organigram.guard';
import { SelectivePreloadStrategy } from './core/preload/selective-preload.strategy';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth-check',
    pathMatch: 'full'
  },
  {
    path: 'auth-check',
    loadChildren: () => import('./auth-check/auth-check.module').then(m => m.AuthCheckPageModule),
  },
  {
    path: 'ai-workflow-popup',
    loadChildren: () => import('./components/ai-workflow-prompt-modal/ai-workflow-prompt-modal.module').then(m => m.AiWorkflowPromptModalModule),
  },
  {
    path: 'database',
    loadChildren: () => import('./data-collections/data-collections.module').then(m => m.DataCollectionsPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'agent-activity-monitor',
    loadChildren: () => import('./agent-activity-monitor/agent-activity-monitor.module').then(m => m.AgentActivityMonitorPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'artifical-intelligence-generation',
  //   loadChildren: () =>
  //     import(
  //       './artifical-intelligence-generation/artifical-intelligence-generation.module'
  //     ).then((m) => m.ArtificalIntelligenceGenerationPageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./signup/signup.module').then((m) => m.SignupPageModule),
  },
  // {
  //   path: 'l',
  //   loadChildren: () =>
  //     import('./landing/landing.module').then((m) => m.LandingModule),
  // },
  // {
  //   path: 'enterprise-sales',
  //   loadChildren: () =>
  //     import('./enterprise-sales/enterprise-sales.module').then((m) => m.EnterpriseSalesModule),
  // },
  // {
  //   path: 'onboarding-agent',
  //   loadChildren: () =>
  //     import('./onboarding-agent/onboarding-agent.module').then((m) => m.OnboardingAgentModule),
  // },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./support/support.module').then((m) => m.SupportPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'password',
    loadChildren: () =>
      import('./password/password.module').then((m) => m.PasswordPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'email',
    loadChildren: () =>
      import('./components/email/email.module').then((m) => m.EmailPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'logo',
    loadChildren: () =>
      import('./components/logo/logo.module').then((m) => m.LogoPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'videos',
    loadChildren: () =>
      import('./videos/videos.module').then((m) => m.VideosPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'communication',
  //   loadChildren: () =>
  //     import('./disposition/communication/communication.module').then(
  //       (m) => m.CommunicationPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'applicants',
    loadChildren: () =>
      import('./recruiting/applicants/applicants.module').then(
        (m) => m.ApplicantsPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'notetaker',
    loadChildren: () =>
      import('./notetaker/notetaker.module').then(
        (m) => m.NotetakerPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'applicant-information',
    loadChildren: () =>
      import(
        './recruiting/applicant-information/applicant-information.module'
      ).then((m) => m.ApplicantInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'applicant-information/:id',
    loadChildren: () =>
      import(
        './recruiting/applicant-information/applicant-information.module'
      ).then((m) => m.ApplicantInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'applicant-create-short-information',
    loadChildren: () =>
      import(
        './recruiting/applicant-create-short-information/applicant-create-short-information.module'
      ).then((m) => m.ApplicantCreateShortInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'customer-request',
  //   loadChildren: () =>
  //     import('./disposition/customer-request/customer-request.module').then(
  //       (m) => m.CustomerRequestPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  // {
  //   path: 'customer-requests',
  //   loadChildren: () =>
  //     import('./disposition/customer-requests/customer-requests.module').then(
  //       (m) => m.CustomerRequestsPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  // {
  //   path: 'customer-request-create',
  //   loadChildren: () =>
  //     import(
  //       './disposition/customer-request-create/customer-request-create.module'
  //     ).then((m) => m.CustomerRequestCreatePageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  // {
  //   path: 'folder/:id',
  //   loadChildren: () =>
  //     import('./folder/folder.module').then((m) => m.FolderPageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardPageModule),
    canActivate: [EnhancedAuthGuard, ProfileCompletionGuard],
  },
  {
    path: 'agent-dashboard',
    loadChildren: () =>
      import('./agent-dashboard/agent-dashboard.module').then((m) => m.AgentDashboardPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'agent-dashboard-public',
    loadChildren: () =>
      import('./agent-dashboard-public/agent-dashboard-public.module').then((m) => m.AgentDashboardPublicPageModule),
    // No auth guard - this is the public version
  },
  {
    path: 'embed',
    loadChildren: () =>
      import('./ars-embed/ars-embed.module').then((m) => m.ArsEmbedModule),
  },
  {
    path: 'new-job-offer',
    loadChildren: () =>
      import('./job-offer/new-job-offer/new-job-offer.module').then(
        (m) => m.NewJobOfferPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'job-offers',
    loadChildren: () =>
      import('./job-offer/job-offers/job-offers.module').then(
        (m) => m.JobOffersPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'job-offer-information',
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            './job-offer/job-offer-information/job-offer-information.module'
          ).then((m) => m.JobOfferInformationPageModule),
        canActivate: [EnhancedAuthGuard],
      },
      {
        path: ':id',
        loadChildren: () =>
          import(
            './job-offer/job-offer-information/job-offer-information.module'
          ).then((m) => m.JobOfferInformationPageModule),
        canActivate: [EnhancedAuthGuard],
      },
      {
        path: 'applicant-information/:id',
        loadChildren: () =>
          import(
            './recruiting/applicant-information/applicant-information.module'
          ).then((m) => m.ApplicantInformationPageModule),
        canActivate: [EnhancedAuthGuard],
      },
    ],
  },
  {
    path: 'job-offer-information/:id',
    loadChildren: () =>
      import(
        './job-offer/job-offer-information/job-offer-information.module'
      ).then((m) => m.JobOfferInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'assessment-test-information',
    redirectTo: 'assessment-tests',
    pathMatch: 'full'
  },
  {
    path: 'delete-job-offer',
    loadChildren: () =>
      import('./job-offer/delete-job-offer/delete-job-offer.module').then(
        (m) => m.DeleteJobOfferPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'job-import-bulk',
    loadChildren: () =>
      import('./job-import-bulk/job-import-bulk.module').then(
        (m) => m.JobImportBulkPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'contracts',
    loadChildren: () =>
      import('./contract/contracts/contracts.module').then(
        (m) => m.ContractsPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'new-contract',
    loadChildren: () =>
      import('./contract/new-contract/new-contract.module').then(
        (m) => m.NewContractPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'contract-information',
    redirectTo: 'contracts',
    pathMatch: 'full'
  },
  {
    path: 'contract-information/:id',
    loadChildren: () =>
      import(
        './contract/contract-information/contract-information.module'
      ).then((m) => m.ContractInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'campaigns',
  //   loadChildren: () =>
  //     import('./campaign/campaigns/campaigns.module').then(
  //       (m) => m.CampaignsPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  // {
  //   path: 'create-campaign',
  //   loadChildren: () =>
  //     import('./campaign/create-campaign/create-campaign.module').then(
  //       (m) => m.CreateCampaignPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'communication-dashboard',
    loadChildren: () =>
      import('./communication/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'team-management',
    loadChildren: () =>
      import('./team-management/team-management.module').then(
        (m) => m.TeamManagementPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'location-teams',
    loadChildren: () =>
      import('./location-teams/location-teams.module').then(
        (m) => m.LocationTeamsPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'customer/:customerId/teammember/:teammemberId/kid/:kidId',
    loadChildren: () =>
      import('./signup/create-password/create-password.module').then(
        (m) => m.CreatePasswordPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'create-workflow',
    loadChildren: () =>
      import('./communication/create-workflow/create-workflow.module').then(
        (m) => m.CreateWorkflowPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'edit-workflow',
    loadChildren: () =>
      import('./communication/edit-workflow/edit-workflow.module').then(
        (m) => m.EditWorkflowPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'edit-workflow/:[id,name,description,type,action,create]',
    loadChildren: () =>
      import('./communication/edit-workflow/edit-workflow.module').then(
        (m) => m.EditWorkflowPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  // preview-file is now an embedded component in applicant-information
  // {
  //   path: 'preview-file/:applicantId/:id',
  //   loadChildren: () =>
  //     import('./shared/preview-file/preview-file.module').then(
  //       (m) => m.PreviewFilePageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'news',
    loadChildren: () =>
      import('./prototypes/noAccessYet/news/news.module').then((m) => m.NewsPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'howto',
    loadChildren: () =>
      import('./howto/howto/howto.module').then((m) => m.HowtoPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'create-howto',
    loadChildren: () =>
      import('./howto/create-howto/create-howto.module').then(
        (m) => m.CreateHowtoPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'help',
    loadChildren: () =>
      import('./help/help.module').then((m) => m.HelpPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'upload',
    loadChildren: () =>
      import('./upload/upload.module').then((m) => m.UploadPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'integrations',
    loadChildren: () =>
      import('./integrations/integrations.module').then(
        (m) => m.IntegrationsPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'add-nonde-popover',
    loadChildren: () =>
      import('./components/add-node-popover/add-node-popover.module').then(
        (m) => m.AddNodePopoverPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'tutorial-popover',
    loadChildren: () =>
      import('./components/tutorial-popover/tutorial-popover.module').then(
        (m) => m.TutorialPopoverPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'tutorial-intro',
    loadChildren: () =>
      import('./tutorial-intro/tutorial-intro.module').then(
        (m) => m.TutorialIntroPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'video-modal',
    loadChildren: () =>
      import('./components/video-image-answer-modal/video-image-answer-modal.module').then(
        (m) => m.VideoImageAnswerModalPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'matching',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('./matching/matching.module').then(
  //           (m) => m.MatchingPageModule,
  //         ),
  //       canActivate: [EnhancedAuthGuard],
  //     },
  //     {
  //       path: 'applicant-information/:id',
  //       loadChildren: () =>
  //         import(
  //           './recruiting/applicant-information/applicant-information.module'
  //         ).then((m) => m.ApplicantInformationPageModule),
  //       canActivate: [EnhancedAuthGuard],
  //     },
  //   ],
  // },
  {
    path: 'blacklist',
    loadChildren: () =>
      import('./blacklist/blacklist.module').then((m) => m.BlacklistPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'update-all-job-offers',
    loadChildren: () =>
      import(
        './job-offer/update-all-job-offers/update-all-job-offers.module'
      ).then((m) => m.UpdateAllJobOffersPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'edit-message-modal',
    loadChildren: () =>
      import('./components/edit-message-modal/edit-message-modal.module').then(
        (m) => m.EditMessageModalPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'edit-message-modal-for-new-job-offer-page',
    loadChildren: () =>
      import(
        './components/edit-message-modal-for-new-job-offer-page/edit-message-modal-for-new-job-offer-page.module'
      ).then((m) => m.EditMessageModalForNewJobOfferModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'get-data-for-ai',
  //   loadChildren: () =>
  //     import('./ai-studio/get-data-for-ai/get-data-for-ai.module').then(
  //       (m) => m.GetDataForAIPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'set-dispo-money-popover',
    loadChildren: () =>
      import(
        './dashboard/set-dispo-money-popover/set-dispo-money-popover.module'
      ).then((m) => m.SetDispoMoneyPopoverPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'create-custom-video',
    loadChildren: () =>
      import('./howto/create-custom-video/create-custom-video.module').then(
        (m) => m.CreateCustomVideoPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'new-assessment-test',
    loadChildren: () =>
      import(
        './assessment-test/new-assessment-test/new-assessment-test.module'
      ).then((m) => m.NewAssessmentTestPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'assessment-tests',
    loadChildren: () =>
      import('./assessment-test/assessment-tests/assessment-tests.module').then(
        (m) => m.AssessmentTestsPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'mona-communication-list',
    loadChildren: () =>
      import(
        './mona-communication/mona-communication-list/mona-communication-list.module'
      ).then((m) => m.MonaCommunicationListPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'assessment-test-information/:id',
    loadChildren: () =>
      import(
        './assessment-test/assessment-test-information/assessment-test-information.module'
      ).then((m) => m.AssessmentTestInformationPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'insights',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./insights/reporting/reporting.module').then(
            (m) => m.ReportingPageModule,
          ),
        canActivate: [EnhancedAuthGuard],
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./insights/reporting/reporting.module').then(
            (m) => m.ReportingPageModule,
          ),
        canActivate: [EnhancedAuthGuard],
      },
    ],
  },
  {
    path: 'contact-form',
    loadChildren: () =>
      import('./contact-form/contact-form.module').then(
        (m) => m.ContactFormPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'data-warehouse',
  //   loadChildren: () =>
  //     import('./data-warehouse/data-warehouse.module').then(
  //       (m) => m.DataWarehousePageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard]
  // },
  {
    path: 'mona-agent-chat',
    loadChildren: () =>
      import('./mona-app/mona-app.module').then(
        (m) => m.MonaAppModule,
      ),
    canActivate: [EnhancedAuthGuard, ProfileCompletionGuard],
  },
  {
    path: 'mona-agent-builder',
    loadChildren: () => import('./mona-agent-builder/mona-agent-builder.module').then(m => m.MonaAgentBuilderPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'company-knowledge',
    loadChildren: () => import('./mona-app/company-knowledge/company-knowledge.module').then(m => m.CompanyKnowledgePageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./payment/payment.module').then((m) => m.PaymentPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'agent-templates',
    loadChildren: () =>
      import('./agent-templates/agent-templates.module').then(
        (m) => m.AgentTemplatesPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'create-agent',
    loadChildren: () =>
      import('./create-agent/create-agent.module').then(
        (m) => m.CreateAgentPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'agent-edit',
    redirectTo: 'mona-agent-builder',
    pathMatch: 'full'
  },
  {
    path: 'agent-edit/:id',
    loadChildren: () =>
      import('./agent-edit/agent-edit.module').then(
        (m) => m.AgentEditPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'chatmona',
  //   loadChildren: () =>
  //     import('./chatmona/chatmona.module').then((m) => m.ChatmonaPageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'pricing',
    loadChildren: () =>
      import('./pricing/pricing.module').then((m) => m.PricingPageModule),
  },
  // {
  //   path: 'activity-center',
  //   loadChildren: () =>
  //     import('./activity-center/activity-center.module').then(
  //       (m) => m.ActivityCenterPageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'terms-of-use',
    loadChildren: () =>
      import('./policies/terms-of-use/terms-of-use.module').then(
        (m) => m.TermsOfUsePageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./policies/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'emailverify/:id',
    loadChildren: () =>
      import('./emailverify/emailverify.module').then(
        (m) => m.EmailverifyPageModule,
      ),
  },
  {
    path: 'success',
    loadChildren: () =>
      import('./payment/success/success.module').then((m) => m.SuccessPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'account-confirmation/:id',
    loadChildren: () =>
      import('./account-confirmation/account-confirmation.module').then(
        (m) => m.AccountConfirmationPageModule,
      ),
    // No auth guard - this page is shown immediately after signup before email verification
  },
  {
    path: 'waitlist-confirm',
    loadChildren: () =>
      import('./waitlist-confirm/waitlist-confirm.module').then(
        (m) => m.WaitlistConfirmPageModule,
      ),
    // No auth guard - this is a candidate-facing page accessed via token
  },
  // TODO: Module not found - community/invite/invite.module
  // {
  //   path: 'invite',
  //   loadChildren: () =>
  //     import('./community/invite/invite.module').then(
  //       (m) => m.InvitePageModule,
  //     ),
  //   canActivate: [EnhancedAuthGuard],
  // },
  // TODO: Module not found - rewards/rewards.module
  // {
  //   path: 'rewards',
  //   loadChildren: () =>
  //     import('./rewards/rewards.module').then((m) => m.RewardsPageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'video-library',
    loadChildren: () =>
      import('./video-libary/video-libary.module').then(
        (m) => m.VideoLibaryPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'video-admin',
    loadChildren: () =>
      import('./video-admin/video-admin.module').then(
        (m) => m.VideoAdminPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'notify-admin',
    loadChildren: () =>
      import('./prototypes/noAccessYet/notify-admin/notify-admin.module').then(
        (m) => m.NotifyAdminPageModule,
      ),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'recruiting-communication',
  //   loadChildren: () => import('./recruiting-communication/recruiting-communication.module').then(m => m.RecruitingCommunicationPageModule),
  //   canActivate: [EnhancedAuthGuard],
  // },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  // {
  //   path: 'workspace',
  //   loadChildren: () => import('./workforce/workspace/workspace.module').then(m => m.WorkspacePageModule),
  //   canActivate: [EnhancedAuthGuard]
  // },
  // TODO: Module not found - workforce/agent/agent.module
  // {
  //   path: 'agent',
  //   loadChildren: () => import('./workforce/agent/agent.module').then(m => m.AgentPageModule),
  //   canActivate: [EnhancedAuthGuard]
  // },
  // {
  //   path: 'agent/:id',
  //   loadChildren: () => import('./workforce/agent/agent.module').then(m => m.AgentPageModule),
  //   canActivate: [EnhancedAuthGuard]
  // },
  {
    path: 'profile-builder',
    loadChildren: () => import('./prototypes/noAccessYet/profile-builder/profile-builder.module').then(m => m.ProfileBuilderPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'org-dashboard',
    loadChildren: () => import('./mona-app/org-dashboard/org-dashboard.module').then(m => m.OrgDashboardPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'workflow-builder',
    loadChildren: () => import('./communication/workflow-builder/workflow-builder.module').then(m => m.WorkflowBuilderPageModule),
    canActivate: [EnhancedAuthGuard, LegacyOrganigramGuard]
  },
  // Standalone organigram page, built on the node model. The legacy workflow-builder route above
  // stays as it is: organizations whose structure lives in Firestore are still served there.
  {
    path: 'organigram',
    loadChildren: () => import('./mona-app/organigram/organigram.module').then(m => m.OrganigramPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'chap',
    loadChildren: () => import('./communication/workflow-builder/workflow-builder.module').then(m => m.WorkflowBuilderPageModule),
    canActivate: [EnhancedAuthGuard, LegacyOrganigramGuard]
  },
  // TODO: Module not found - data-pipeline/data-pipeline.module
  {
    path: 'mcp',
    loadChildren: () => import('./mcp-settings/mcp-page.module').then(m => m.McpPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'data-pipeline',
    loadChildren: () => import('./data-pipeline/data-pipeline.module').then(m => m.DataPipelinePageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'user-handbook',
    loadChildren: () => import('./user-handbook/user-handbook.module').then(m => m.UserHandbookPageModule),
    canActivate: [EnhancedAuthGuard],
  },
  {
    path: 'trust',
    loadChildren: () => import('./prototypes/noAccessYet/trust/trust.module').then(m => m.TrustPageModule)
  },
  {
    path: 'email-inbox',
    loadChildren: () => import('./prototypes/noAccessYet/email-inbox/email-inbox.module').then(m => m.EmailInboxPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'sms-inbox',
    loadChildren: () => import('./prototypes/noAccessYet/sms-inbox/sms-inbox.module').then(m => m.SmsInboxPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'vms-form-automation',
    loadChildren: () => import('./vms-form-automation/vms-form-automation.module').then(m => m.VmsFormAutomationPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'admin-onboarding',
    loadChildren: () => import('./admin-onboarding/admin-onboarding.module').then(m => m.AdminOnboardingPageModule)
  },
  {
    path: 'user-onboarding',
    loadChildren: () => import('./user-onboarding/user-onboarding.module').then(m => m.UserOnboardingModule)
  },
  {
    path: 'flow-preview/:key',
    loadChildren: () =>
      import('./flow-preview/flow-preview.module').then((m) => m.FlowPreviewPageModule),
  },
  {
    path: 'hybrid-dashboard',
    loadChildren: () => import('./hybrid-dashboard/hybrid-dashboard.module').then(m => m.HybridDashboardPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'pool-monetization',
    loadChildren: () => import('./pool-monetization/pool-monetization.module').then(m => m.PoolMonetizationPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'referral',
    loadChildren: () => import('./referral/referral.module').then(m => m.ReferralPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'pool-collaboration',
    loadChildren: () => import('./pool-collaboration/pool-collaboration.module').then(m => m.PoolCollaborationPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'mona-live',
    loadChildren: () => import('./mona-live/mona-live.module').then(m => m.MonaLivePageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'searches',
    loadChildren: () => import('./searches/searches.module').then(m => m.SearchesPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'shortlist',
    loadChildren: () => import('./shortlist/shortlist.module').then(m => m.ShortlistPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: 'external-job-offers',
    loadChildren: () => import('./external-job-offers/external-job-offers.module').then(m => m.ExternalJobOffersPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  // Path deliberately avoids the substring '/pricing': EnhancedAuthGuard's no-database deny-list
  // is matched with url.includes(), so '/admin/pricing' would be treated as a route that needs no
  // tenant database and the page would load with no usage data.
  {
    path: 'admin/agent-costs',
    loadChildren: () => import('./admin/pricing/pricing-admin.module').then(m => m.PricingAdminPageModule),
    canActivate: [EnhancedAuthGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadStrategy }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
